/**
 * Created by admin on 2018/4/8.
 */
import request from '../utils/request';

export const findMeetingDetail = (locale, meetingId) => {
  return request(
    `/smartmeeting/smart/third/findMeetingDetail?lang=${locale}&meetingId=${meetingId}`
  );
};

export function getCmmaAuth() {
  return request(`/smartmeeting/smart/third/getCmmaAuth`);
}

export function getAllCmmaDevice(domainId) {
  return request(`/smartmeeting/smart/third/findAllCmmaDevice?domainId=${domainId}`);
}

export function getCospacesBulk() {
  return request(`/smartmeeting/smart/third/getCospacesBulk`);
}

export function syncCospacesBulk({startIndex, cospacesBulkName, cospacesCount}) {
  const url = `/smartmeeting/smart/third/syncCospacesBulk?startIndex=${startIndex}&cospacesCount=${cospacesCount}&cospacesBulkName=${cospacesBulkName}`;
  return request(url, { method: 'POST'})
}

export function updateCmmaInfo(meetingControl) {
  let url = '/smartmeeting/smart/third/updateCmmaInfo';
  Object.keys(meetingControl).forEach(key => {
    url +=
      url.indexOf('?') === -1
        ? `?${key}=${meetingControl[key]}`
        : `&${key}=${meetingControl[key]}`;
  });
  return request(url, { method: 'POST' });
}

export function getCmmaInfo(meetingId) {
  return request(`/smartmeeting/smart/third/cmmaInfo?meetingId=${meetingId}`);
}

export function getFuIdListByMeetingId(meetingId, lang) {
  return request(
    `/smartmeeting/smart/third/getFuIdListByMeetingId?meetingId=${meetingId}&lang=${lang}`
  );
}

export function cmmaStatus(meetingId) {
  return request(`/smartmeeting/smart/third/cmmaStatus?meetingId=${meetingId}`);
}

export function startNow(meetingId, email, domainName) {
  return request(
    `/smartmeeting/smart/third/startNow?meetingId=${meetingId}&email=${email}&domainName=${domainName}`
  );
}

export function addOnRoom(meetingId, number, domainId) {
  return request(
    `/smartmeeting/smart/third/addOnRoom?meetingId=${meetingId}&address=${number}&domainId=${domainId}`
  );
}

export function rmvParticipant(meetingId, address, domainId) {
  return request(
    `/smartmeeting/smart/third/removeParticipant?meetingId=${meetingId}&address=${address}&domainId=${domainId}`
  );
}

export function resetCmmaInfo(meetingId) {
  return request(
    `/smartmeeting/smart/third/resetCmmaInfo?meetingId=${meetingId}`
  );
}

export function cancelMeeting(meetingId, type, userId, lang) {
  return request(
    `/smartmeeting/smart/third/cancelMeeting?meetingId=${meetingId}&type=${type}&userId=${userId}&lang=${lang}`
  );
}

export function stopMeeting(meetingId, userId, lang) {
  return request(
    `/smartmeeting/smart/board/end?meetingId=${meetingId}&userId=${userId}&lang=${lang}`
  );
}

export function allCMMARooms(domain) {
  return request(`/smartmeeting/smart/third/allCmmaRoom?domainName=${domain}`);
}

export function addingFailed(meetingId, cmmaRoomId, domainId) {
  return request(
    `/smartmeeting/smart/third/addingFailed?meetingId=${meetingId}&cmmaRoomId=${cmmaRoomId}&domainId=${domainId}`,
    { method: 'POST' }
  );
}

export const delayCallNum = (callNum, mins) => {
  return request(
    `/smartmeeting/smart/third/callNumDelay?callNum=${callNum}&mins=${mins}`
  );
};



// WEBPACK FOOTER //
// ./src/services/cmmaService.js